import { zetApi } from '@zet/network'

import { UploadLoanDocumentToS3Props } from '../../types'
import ENDPOINTS from '../endpoints'

const uploadLoanDocumentToS3 = ({
  file,
  customerId,
  onecode,
  ocFieldCode,
  partnerId,
  uploadProgress,
  fileName,
}: UploadLoanDocumentToS3Props) => {
  return new Promise((resolve, reject) => {
    zetApi
      .request({
        method: ENDPOINTS.uploadLoanDocument.method,
        url: ENDPOINTS.uploadLoanDocument.endpoint,
        params: {
          partnerId,
          customerId,
          onecode,
          ocFieldCode,
          fileName,
        },
        data: file,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (ev) => {
          const progress = Math.round((ev.loaded * 100) / Number(ev.total))
          if (uploadProgress) uploadProgress(progress) // Call the progress callback
        },
      })
      .then((response) => resolve({ response }))
      .catch((error) => reject(error))
  })
}

export default uploadLoanDocumentToS3
